import { render } from "./WalletDisplayNameModal.vue?vue&type=template&id=457e31c4"
import script from "./WalletDisplayNameModal.vue?vue&type=script&lang=js"
export * from "./WalletDisplayNameModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__